import styled from "styled-components";

export const StyledLayout = styled.div`
  width: 100%;
  height: calc(100vh - 74px);
  overflow: hidden;
`;
